/* tslint:disable */
/* eslint-disable */
/* @relayHash f88bdc9097f2efa2eb924e82c0f1ee53 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewInstagramRefetchQueryVariables = {
    firmUrlLabel: string;
    isEditMode: boolean;
};
export type OverviewInstagramRefetchQueryResponse = {
    readonly viewer: {
        readonly tradeFirms: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"OverviewInstagram_tradeFirm">;
        } | null> | null;
    };
};
export type OverviewInstagramRefetchQuery = {
    readonly response: OverviewInstagramRefetchQueryResponse;
    readonly variables: OverviewInstagramRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "firmUrlLabel",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isEditMode",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "urlLabel",
    "variableName": "firmUrlLabel"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "OverviewInstagramRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirms",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TradeFirmType",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "OverviewInstagram_tradeFirm",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "OverviewInstagramRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirms",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TradeFirmType",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "instagram",
                "storageKey": null,
                "args": null,
                "concreteType": "InstagramFeedType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "feed",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InstagramFeedItemType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "imageUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "link",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isEditMode",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "username",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "OverviewInstagramRefetchQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/OverviewInstagramRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '3092b55d77cc31df57f6b021f66f0bcb';
export default node;
